export class PalletData {

    static palletImages = [];
    static selectedRoutes = "";
    static selectedOperators = "";
    static selectedWrappers = "";
    static selectedInferences = "";

    static selectedRouteValues = [];
    static selectedOperatorValues = [];
    static selectedWrapperValues = [];
    static selectedInferenceValues = [];

    static isRouteSelected = false
    static isOpratorSelected = false;
    static isWrapperSelected = false;
    static isInferenceSelected = false;
    static imageNotExist = "ImageNotExist";

    static selAllRoutes = [];
    static selAllWrappers = [];
    static selAllSelectors = [];
    static selAllInferences = [];

    static palletStatues = ['VOR Verified','Verified/Needs Confirmation','Error Found','Contains Untrained SKU','System Error']

    static isPalletImageExist = (picklistId,inference_id)=>{
      // if(PalletData.palletImages.indexOf())
        let arr = PalletData.palletImages;
        if(arr.length>0){
            let obj = arr.find(o => o.Key === picklistId && o.Inference == inference_id);
            if(obj){
                return obj.Value;
            }
        }
        return null;

    }

    static savePalletImages = (picklistId,imgUrl,inference_id)=>{
        //let arr = PalletData.palletImages;

        PalletData.palletImages.push({Key:picklistId,Value:imgUrl,Inference:inference_id});
        //return imgUrl;
    }

}
